export default __webpack_public_path__ + "static/media/icon-x-gray.1c49cf0b.svg";